import { DateTime as DateTime$1 } from "../../../../../components/DateTime/index.js";
import { isSignatureValue } from "../../../../../components/SignaturePad/signature-path.js";
import { SignatureDisplay } from "../../../../../components/SignaturePad/SignatureDisplay.js";
import { FieldDisplayRenderWrapper } from "../components/FieldDisplayRenderWrapper.js";
import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import "react";
import { Label } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Signature/Display.tsx
var SignatureFieldDisplay = ({ config }) => {
	const { valuesByFieldId } = useFormBuilderFieldsContext();
	const value = valuesByFieldId[config.id];
	if (!value) return null;
	const hasInk = !isSignatureValue(value) || !!value.d;
	return /* @__PURE__ */ jsx(FieldDisplayRenderWrapper, {
		config,
		children: /* @__PURE__ */ jsxs("div", { children: [
			/* @__PURE__ */ jsxs(Label, { children: [config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {}), config.options.displayLabel] }),
			hasInk ? /* @__PURE__ */ jsx(SignatureDisplay, {
				scale: .5,
				value
			}) : /* @__PURE__ */ jsx("div", {
				className: "text-color-subtle text-sm italic",
				children: "No signature captured"
			}),
			(value.signerName || value.signedAt) && /* @__PURE__ */ jsxs("div", {
				className: "text-color-subtle text-sm",
				children: [
					value.signerName && /* @__PURE__ */ jsx("span", { children: hasInk ? `Signed by ${value.signerName}` : `Name: ${value.signerName}` }),
					value.signerName && value.signedAt && /* @__PURE__ */ jsx("span", { children: " · " }),
					value.signedAt && /* @__PURE__ */ jsx(DateTime$1, { timestamp: value.signedAt })
				]
			})
		] })
	});
};
//#endregion
export { SignatureFieldDisplay };

//# sourceMappingURL=Display.js.map